import { InjectionToken } from '@angular/core';
import { IInitializable } from '~interfaces';


export const INITIALIZABLE = new InjectionToken<IInitializable>(
    'Initializable service'
);
